import React, { useState, useEffect, useRef } from 'react';
import { Accordion } from 'react-bootstrap';
import Panel from '../../previewPanel/containers/panel';
import '../style.css';
//import { useParams } from 'react-router-dom';

export default function GraphMenuComponent({
  availableGraphs,
  handleAddGraphToDashboard,
  removeGraphFromDashboard,
  selectedGraphs: propSelectedGraphs,
  setShowToast,
  handleClose,
  dashboardName
}) {
  const [selectedGraphIds, setSelectedGraphIds] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [activeLayerKey, setActiveLayerKey] = useState(null);
  //console.log("propSelectedGraphs", availableGraphs)
  // const { id } = useParams();

  const pathSegments = window.location.pathname.split('/');
  // const dashboardId = pathSegments.pop(); // Gets the ID
  const isEditMode = pathSegments.includes('viewDashboardList');

  const sidebarRef = useRef(null); //Reference to sidebar
  // const panelRef = useRef(null);
  //click on outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the preview panel is open, disable outside-click-to-close
      if (showPreview) return;

      // Check if clicked outside the sidebar
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClose, showPreview]);

  useEffect(() => {
    if (propSelectedGraphs && propSelectedGraphs.length > 0) {
      setSelectedGraphIds(propSelectedGraphs.map((graph) => graph.id));

      // Only auto-show preview in edit mode
      if (isEditMode) {
        // or isEditMode if you have that variable
        setShowPreview(true);
      }
    }
  }, [propSelectedGraphs, isEditMode]); // Add id to dependencies

  const toggleGraphSelection = (graph) => {
    //console.log("selectId", selectedGraphIds);
    setSelectedGraphIds((prev) => {
      const isSelected = prev.includes(graph.id);
      const updated = isSelected ? prev.filter((id) => id !== graph.id) : [...prev, graph.id];

      if (isSelected) {
        removeGraphFromDashboard(graph.id);
      } else {
        handleAddGraphToDashboard(graph);
      }
      return updated;
    });
  };

  const handlePreview = () => {
    if (selectedGraphIds.length > 0) {
      setShowPreview(true);
    } else {
      setShowToast({ show: true, variant: 'danger', message: 'Please select at least one graph' });
    }
  };

  // const handleClosePreview = () => {
  //   console.log("panel close")
  //   setShowPreview(false);
  //   setSelectedGraphIds([]);
  //   availableGraphs=""
  // };

  const handleGraphsUpdate = (updatedGraphs) => {
    setSelectedGraphIds(updatedGraphs.map((graph) => graph.id));
  };

  const groupedByLayerType = availableGraphs.reduce((acc, layer) => {
    const type = layer.layer_type || 'unknown';
    if (!acc[type]) acc[type] = [];

    const existingLayer = acc[type].find((l) => l.name === layer.name);
    if (existingLayer) {
      existingLayer.graphs = [...(existingLayer.graphs || []), ...(layer.graphs || [])];
    } else {
      acc[type].push({ ...layer, graphs: [...(layer.graphs || [])] });
    }

    return acc;
  }, {});

  const groupGraphsByCategory = (graphs = []) => ({
    graphs: graphs.filter((g) => !g.category || g.category === 'graph'),
    equipment_kpi: graphs.filter((g) => g.category === 'equipment_kpi'),
    machine_status: graphs.filter((g) => g.category === 'machine_status')
  });
//console.log("graoh,", groupGraphsByCategory.graphs)
  const renderGraphList = (graphs) => (
    <ul className="list-unstyled ms-3 mt-2">
      {graphs.map((graph, i) => (
        <li key={i} className="d-flex justify-content-between align-items-start py-1">
          <span className="flex-grow-1 text-start">{graph.graph_list_name}</span>
          <input
            type="checkbox"
            checked={selectedGraphIds.includes(graph.id)}
            onChange={() => toggleGraphSelection(graph)}
            className="ms-2 custom-checkbox"
            style={{ flexShrink: 0 }}
          />
        </li>
      ))}
    </ul>
  );

  return (
    <div className="graph-container d-flex">
      {/* Graph Selection Panel */}
     <div
  className={`${isEditMode ? 'selectGraph-slider' : 'sidebar-slider'} graph-accordion`}
  ref={sidebarRef}
>
        <i
          className={`sidebar-slider_close material-icons ${showPreview ? 'disabled-icon' : ''}`}
          onClick={showPreview ? undefined : handleClose}>
          cancel
        </i>

        <div className="select-source">
          <h3 className="text-center py-4">Select graphs</h3>

          {/* Show loading if no graphs */}
          {!availableGraphs || availableGraphs.length === 0 ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <Accordion activeKey={activeLayerKey} onSelect={(k) => setActiveLayerKey(k)}>
              {Object.entries(groupedByLayerType).map(([layerType, layers], parentIndex) => (
                <Accordion.Item eventKey={String(parentIndex)} key={parentIndex}>
                  <Accordion.Header>
                    {layerType.charAt(0).toUpperCase() + layerType.slice(1)}
                  </Accordion.Header>
                  <Accordion.Body>
                    {layers.length > 1 ? (
                      <Accordion alwaysOpen>
                        {layers.map((layer, index) => {
                          const categories = groupGraphsByCategory(layer.graphs);
                          return (
                            <Accordion.Item eventKey={`layer-${parentIndex}-${index}`} key={index}>
                              <Accordion.Header>{layer.name}</Accordion.Header>
                              <Accordion.Body>
                                <div className="graph-name">
                                  {renderGraphList(categories.graphs)}
                                </div>

                                {categories.equipment_kpi.length > 0 && (
                                  <details open className="mb-2">
                                    <summary className="fw-bold">Equipment KPI</summary>
                                    <div className="graph-name">
                                      {' '}
                                      {renderGraphList(categories.equipment_kpi)}
                                    </div>
                                  </details>
                                )}

                                {categories.machine_status.length > 0 && (
                                  <details open className="mb-2">
                                    <summary className="fw-bold">Machine Status</summary>
                                    <div className="graph-name">
                                      {renderGraphList(categories.machine_status)}
                                    </div>
                                  </details>
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                      </Accordion>
                    ) : (
                      // Direct rendering for single layer (no nested accordion)
                      (() => {
                        const categories = groupGraphsByCategory(layers[0].graphs);
                        return (
                          <>
                            <div className="graph-name"> {renderGraphList(categories.graphs)}</div>

                            {categories.equipment_kpi.length > 0 && (
                              <details open className="mb-2">
                                <summary className="fw-bold">Equipment KPI</summary>
                                <div className="graph-name">
                                  {' '}
                                  {renderGraphList(categories.equipment_kpi)}
                                </div>
                              </details>
                            )}

                            {categories.machine_status.length > 0 && (
                              <details open className="mb-2">
                                <summary className="fw-bold">Machine Status</summary>
                                <div className="graph-name">
                                  {' '}
                                  {renderGraphList(categories.machine_status)}
                                </div>
                              </details>
                            )}
                          </>
                        );
                      })()
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}

          <div>
            <button
              className="btn mt-5 btn-grad pr-5 pl-5 mx-auto"
              type="button"
              onClick={handlePreview}
              disabled={selectedGraphIds.length === 0}>
              Preview
            </button>
          </div>
        </div>
      </div>

      {/* Preview Panel */}
      {showPreview && (
        <div>
          <Panel
            selectedGraphs={propSelectedGraphs}
            onReorder={handleGraphsUpdate}
            handleClose={handleClose}
            removeGraphFromDashboard={removeGraphFromDashboard}
            dashboardName={dashboardName}
          />
        </div>
      )}
    </div>
  );
}
